var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 542,
    zoomAndPan: "magnify",
    viewBox: "0 0 406.5 406.499996",
    height: 542,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1cf160821a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.109375 0 L 365.457031 0 L 365.457031 406 L 41.109375 406 Z M 41.109375 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1cf160821a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 365.273438 88.632812 L 365.273438 87.363281 C 365.273438 87.363281 365.273438 86.726562 364.953125 86.410156 L 364.953125 86.089844 C 364.953125 85.773438 364.636719 85.457031 364.636719 85.140625 L 364.636719 84.820312 C 364.320312 84.503906 364 84.1875 364 83.867188 L 281.402344 1.269531 C 281.085938 0.953125 280.769531 0.636719 280.449219 0.636719 L 280.132812 0.636719 C 279.816406 0.316406 279.496094 0.316406 279.179688 0.316406 L 278.863281 0.316406 C 278.542969 0.316406 278.226562 0 277.910156 0 C 277.589844 0 276.957031 0 276.636719 0 L 60.296875 0 C 49.8125 0 41.234375 8.578125 41.234375 19.0625 L 41.234375 387.570312 C 41.234375 398.054688 49.8125 406.632812 60.296875 406.632812 L 346.210938 406.632812 C 356.695312 406.632812 365.273438 398.054688 365.273438 387.570312 Z M 352.5625 387.253906 C 352.5625 390.75 349.707031 393.609375 346.210938 393.609375 L 60.296875 393.609375 C 56.800781 393.609375 53.945312 390.75 53.945312 387.253906 L 53.945312 18.742188 C 53.945312 15.25 56.800781 12.390625 60.296875 12.390625 L 269.96875 12.390625 L 269.96875 67.347656 C 269.96875 82.597656 282.355469 94.988281 297.605469 94.988281 L 352.5625 94.988281 Z M 352.5625 387.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6caa94cd.svg";
export { ForwardRef as ReactComponent };